import React from "react";
import { Modal, ModalBody } from "reactstrap";
import success from "assets/images/check-circle.svg";
import close from "assets/images/close.svg";

const PasswordSuccess = ({ isOpen, toggle }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalBody>
        <div className="success_popup">
          <img src={close} className="close_icon" onClick={() => toggle()} />
          <img src={success} />
          <b>Password has been changed successfully</b>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PasswordSuccess;
